/**
 * Renders FAQ answer text with paragraph breaks (\n\n) and bullet lines (•).
 */
function FaqAnswerBody({ text, className = 'faq-article-answer' }) {
  if (!text) return null;

  const blocks = String(text).split('\n\n').filter((b) => b.trim());

  return (
    <div className={className}>
      {blocks.map((block, blockIndex) => {
        const lines = block.split('\n').map((l) => l.trim()).filter(Boolean);
        const isBulletList = lines.length > 0 && lines.every((l) => l.startsWith('•'));

        if (isBulletList) {
          return (
            <ul key={blockIndex} className="faq-article-list">
              {lines.map((line, lineIndex) => (
                <li key={lineIndex}>{line.replace(/^•\s*/, '')}</li>
              ))}
            </ul>
          );
        }

        return <p key={blockIndex}>{block}</p>;
      })}
    </div>
  );
}

export default FaqAnswerBody;
